import MedalComponent from "./MedalComponent.jsx";

function TournamentComponent({ tournamentName, tournamentDate, medals }) {
  const medalTypes = Object.entries(medals).filter(
    ([, athletes]) => athletes?.length > 0,
  );

  const medalCount = medalTypes.length;

  const spanClass = {
    1: "col-span-6",
    2: "col-span-3",
    3: "col-span-2",
  }[medalCount];

  return (
    <div className="">
      <div className="tournament-data">
        <span className="tournament-name">{tournamentName}</span>
        {/* <span> - </span>
        <span className="tournament-date">{tournamentDate}</span> */}
      </div>
      <div className="tournament-medals-grid">
        {medals["Oro"]?.length > 0 && (
          <div className={spanClass}>
            <MedalComponent type="gold" athletes={medals["Oro"]} />
          </div>
        )}

        {medals["Argento"]?.length > 0 && (
          <div className={spanClass}>
            <MedalComponent type="silver" athletes={medals["Argento"]} />
          </div>
        )}

        {medals["Bronzo"]?.length > 0 && (
          <div className={spanClass}>
            <MedalComponent type="bronze" athletes={medals["Bronzo"]} />
          </div>
        )}
      </div>
      {/* <MedalComponent type="gold" athletes={medals["Oro"]} />
        <MedalComponent type="silver" athletes={medals["Argento"]} />
        <MedalComponent type="bronze" athletes={medals["Bronzo"]} /> */}

      {/* {medals["Oro"]?.length > 0 && (
          <MedalComponent type="gold" athletes={medals["Oro"]} />
        )}
        {medals["Argento"]?.length > 0 && (
          <MedalComponent type="silver" athletes={medals["Argento"]} />
        )}
        {medals["Bronzo"]?.length > 0 && (
          <MedalComponent type="bronze" athletes={medals["Bronzo"]} />
        )} */}
    </div>
  );
}

export default TournamentComponent;
